var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar Panel icon Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.25,15 L15,15 L15,21.25 L21.25,21.25 L21.25,15 L21.25,15 Z M20,1.25 L20,3.75 L10,3.75 L10,1.25 L7.5,1.25 L7.5,3.75 L6.25,3.75 C4.8625,3.75 3.7625,4.875 3.7625,6.25 L3.75,23.75 C3.75,25.125 4.8625,26.25 6.25,26.25 L23.75,26.25 C25.125,26.25 26.25,25.125 26.25,23.75 L26.25,6.25 C26.25,4.875 25.125,3.75 23.75,3.75 L22.5,3.75 L22.5,1.25 L20,1.25 L20,1.25 Z M23.75,23.75 L6.25,23.75 L6.25,10 L23.75,10 L23.75,23.75 L23.75,23.75 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 62.5,
    height: 62.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "white",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar-Panel-icon-Copy",
    transform: "translate(-3.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_event"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/UpScript-grey",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.250000, -16.250000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Black",
    stroke: "none",
    fill: "white",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.aa623bc5b278b696da3f26c928c8e381.svg";
export { ForwardRef as ReactComponent };